import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../@types/RootState';

export type SaveFilterData = Record<'label' | 'value' | 'name', string>;

export type SaveFiltersState = {
  isOpen: boolean;
  name: string;
  data: SaveFilterData | null;
  dataItem: DataItem[];
};

const initialState: SaveFiltersState = {
  isOpen: false,
  name: '',
  data: null,
  dataItem: [],
};

const slice = createSlice({
  name: 'ipa.priceManager.modals.saveFilters',
  initialState,
  reducers: {
    SET_IS_OPEN(state, action: PayloadAction<boolean>) {
      state.isOpen = action.payload;
    },
    SET_NAME(state, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    SET_DATA(state, action: PayloadAction<SaveFilterData | null>) {
      state.data = action.payload;
    },
    SET_DATA_ITEM(state, action: PayloadAction<DataItem[]>) {
      state.dataItem = action.payload;
    },
    RESET() {
      return initialState;
    },
    RESET_WITHOUT_DATA_ITEM(state) {
      state.isOpen = initialState.isOpen;
      state.name = initialState.name;
      state.data = initialState.data;
    },
    SET_STATE(state, action: PayloadAction<Partial<SaveFiltersState>>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { SET_IS_OPEN, SET_NAME, SET_DATA, SET_DATA_ITEM, RESET, RESET_WITHOUT_DATA_ITEM, SET_STATE } = slice.actions;

export default slice.reducer;

export const selectorSaveFilters = (state: RootState) => {
  return state.ipa.priceManager.modals.saveFilters;
};
